export enum CalculationPayInType {
    REGULAR = 'regular',
    INCLUSIVE = 'inclusive',
}
